module.exports = __webpack_public_path__ + "static/media/gry-ortograficzne-dla-dzieci.ff0d37f4.png";